<mat-form-field #formFieldContainer floatLabel="always" class="avl-animation-gmap-wrapper"  >
    <mat-label
      #labelContainer  (click)="toggleTooltip(tooltip)"
      class="{{componentDefinition?.mandatory ? 'mandatory' : ''}}">
      {{componentDefinition?.label}}
    </mat-label>
    <div class="labelToolTipContainer"
         #tooltip="matTooltip"
         matTooltip="{{componentDefinition.label}}"
         [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
    </div>
    <input matInput hidden />
    <div id="parent_div_1">

        <select id="type" hidden=true>
            <option value="LineString">LineString</option>
            <option value="Point">Point</option>
            <option value="Polygon">Polygon</option>
            <option value="Circle">Circle</option>
        </select>

        <div #targetMap id="fieldName+'map'" class="map">

        </div>

        <br>
        <mat-checkbox value="toggleDebug" (click)="setDebug(toggleDebug)" color="primary">
            Debug
         </mat-checkbox>
        <br>

    </div>
</mat-form-field>
